import { useEffect, useState } from "react";
import { Phone } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F4F3EF]/95 backdrop-blur-md border-b border-[#121C17]/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <a
          data-testid="navbar-logo"
          href="#top"
          className="flex items-center gap-3 group"
        >
          <span className="cross-icon" aria-hidden />
          <div className="leading-[0.95]">
            <div className="font-display text-[20px] uppercase tracking-tight">
              Crosscut
            </div>
            <div className="font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#4A5D53]">
              Lawn Care · TC
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              href={l.href}
              className="nav-link font-semibold text-sm uppercase tracking-[0.18em] text-[#0B1C14] hover:text-[#E64C23] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="navbar-phone"
            href="tel:+12314635080"
            className="hidden sm:flex items-center gap-2 font-mono-accent text-xs uppercase tracking-[0.18em] text-[#0B1C14] hover:text-[#E64C23] transition-colors"
          >
            <Phone size={14} strokeWidth={2.5} />
            (231) 463-5080
          </a>
          <a
            data-testid="navbar-cta-quote"
            href="#contact"
            className="btn-primary !px-5 !py-3 !text-[11px]"
          >
            Free Quote
          </a>
          <button
            data-testid="navbar-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden ml-1 w-10 h-10 flex flex-col items-center justify-center gap-[5px] border-2 border-[#0B1C14]"
            aria-label="Open menu"
          >
            <span className="block w-5 h-[2px] bg-[#0B1C14]" />
            <span className="block w-5 h-[2px] bg-[#0B1C14]" />
            <span className="block w-5 h-[2px] bg-[#0B1C14]" />
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-[#F4F3EF] border-t border-[#121C17]/10 px-6 py-6 flex flex-col gap-5"
        >
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-display text-2xl uppercase tracking-tight text-[#0B1C14]"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
